import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appDate]',
})
export class DateDirective {
  private element: HTMLInputElement;

  constructor(private el: ElementRef) {
    this.element = this.el.nativeElement;
  }

  @HostListener('input')
  public onKeyUp(): void {
    this.getFormattedValue();
  }

  private getFormattedValue() {
    let valueNumber = this.element.value.replace(/\D/g, '');
    if (valueNumber.length > 8) {
      valueNumber = valueNumber.substr(0, 8);
    }

    const match = valueNumber.match(/^(\d{1,2})(\d{0,2})(\d{0,4})$/);
    if (match) {
      valueNumber = `${match[1]}${match[2] ? '/' : ''}${match[2]}${match[3] ? '/' : ''}${match[3]}`;
    }

    this.element.value = valueNumber;
  }
}
